// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"89b6a853","329":"6997d42d","446":"b38af71c","460":"99a557c6","488":"22b449f6","551":"52e4c040","728":"29fe088c","730":"c02a476f","880":"4e29ae3b","913":"f3ca13e7","969":"5babfcf7","979":"d34518b1"}[chunkId] + ".chunk.js";
};